import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [allRows, setAllRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);

  const DefaultColumns = [
    { field: 'Error Message' },
    { field: 'Retry Attempts' },
    { field: 'Status' },
    { field: 'Creation Date' },
    { field: 'Truck Number' },
    { field: 'Device ID' },
    { field: 'Tag Id' },
    { field: 'Address' },
    { field: 'Tip Date' },
    { field: 'Event Type' }
  ];

  useEffect(() => {
    if (searchVal && searchVal !== "") {
      let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);
 
  var dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      if (dateParts && dateParts.length <= 2) return -1;
      var cellDate = new Date(
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0]),
        Number(dateParts[0]) - 1,
        Number(dateParts[1])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;

        if (keys[i] === "errorMessage") {
          obj = { headerName: 'Error Message', field: keys[i] }
        }
        else if (keys[i] === "retryAttempts") {
          obj = { headerName: 'Retry Attempts', field: keys[i], filter: 'agNumberColumnFilter' }
        }
        else if (keys[i] === "status") {
          obj = { headerName: 'Status', field: keys[i] }
        }
        else if (keys[i] === "creationDate") {
          obj = { headerName: 'Creation Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "truckNumber") {
          obj = { headerName: 'Truck Number', field: keys[i] }
        }
        else if (keys[i] === "deviceName") {
          obj = { headerName: 'Device ID', field: keys[i] }
          }
        else if (keys[i] === "tagId") {
          obj = { headerName: 'Tag Id', field: keys[i] }
        }
        else if (keys[i] === "address") {
          obj = { headerName: 'Address', field: keys[i] }
        }
        else if (keys[i] === "eventDate") {
          obj = { headerName: 'Tip Date', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "eventType") {
          obj = { headerName: 'Event Type', field: keys[i] }
        }
        if (obj)
              newKeys.push(obj);

      }
      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns(DefaultColumns);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };
    // Downloading Only Filtered Data After Search
    useEffect(() => {
      if (getFilteredData)
        getFilteredData(rows);
    },[rows]);


  return (
    <Box className="ag-theme-material" sx={{ height: "75%", width: '100%' }}>
      <AgGridReact
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={200}
        suppressHorizontalScroll={false}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}    
        defaultColDef={defaultColDef}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;
